import { Enum  } from "./Enum";

export const OrderTypeEnum: Enum[] = [
  { id: 'sample', name: 'Sample' },
  { id: 'fabric', name: 'Fabric' }
];